export default "__VITE_ASSET__9d72d576__"